import { render } from "./RegionsDropdown.vue?vue&type=template&id=285e4550"
import script from "./RegionsDropdown.vue?vue&type=script&lang=js"
export * from "./RegionsDropdown.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__